import Vue from "vue"
import Notification from "vue-notification"
import { AxiosError } from "axios"
import { isObject, isEmpty } from "@/utils/validate"

Vue.use(Notification)

function stringify(data: any): string {
    return isObject(data) ? JSON.stringify(data) : !isEmpty(data) ? data : ""
}

export const notifyRequestTimeout = () => {
    Vue.prototype.$notify({
        group: "SBL_MANAGER",
        type: "error",
        title: "Time out (default set to 10 seconds)",
        text: "Request has been aborted",
    })
}

export const notifyRequestError = (
    error: AxiosError,
    title = "",
    text = ""
) => {
    if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        Vue.prototype.$notify({
            group: "SBL_MANAGER",
            type: "error",
            title,
            text: `status: ${error.response.status}, message: ${text ||
                stringify(error.response.data) ||
                error.response.statusText}`,
        })
    } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        Vue.prototype.$notify({
            group: "SBL_MANAGER",
            type: "error",
            title,
            text: "No response from the server",
        })
    } else {
        // Something happened in setting up the request that triggered an error
        Vue.prototype.$notify({
            group: "SBL_MANAGER",
            type: "error",
            title,
            text: error.message || "Failed to setup the request",
        })
    }
}

export const notifyRequestWarn = (error: AxiosError, title = "", text = "") => {
    if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        Vue.prototype.$notify({
            group: "SBL_MANAGER",
            type: "warn",
            title,
            text: `status: ${error.response.status}, message: ${text ||
                stringify(error.response.data) ||
                error.response.statusText}`,
        })
    } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        Vue.prototype.$notify({
            group: "SBL_MANAGER",
            type: "warn",
            title,
            text: "No response from the server",
        })
    } else {
        // Something happened in setting up the request that triggered an error
        Vue.prototype.$notify({
            group: "SBL_MANAGER",
            type: "warn",
            title,
            text: error.message || "Failed to setup the request",
        })
    }
}

export const notifySuccess = (title = "", text = "") => {
    Vue.prototype.$notify({
        group: "SBL_MANAGER",
        type: "success",
        title,
        text,
    })
}

export const notifyError = (title = "", text = "") => {
    Vue.prototype.$notify({
        group: "SBL_MANAGER",
        type: "error",
        title,
        text,
    })
}

export const notifyWarn = (title = "", text = "") => {
    Vue.prototype.$notify({
        group: "SBL_MANAGER",
        type: "warn",
        title,
        text,
    })
}

export const notifyInfo = (title = "", text = "") => {
    Vue.prototype.$notify({
        group: "SBL_MANAGER",
        type: "info",
        title,
        text,
    })
}
